var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "lo-icon-btn lo-icon-btn--nm-icon-text",
      attrs: { href: "javascript:void(0)" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("SVGArrowCircleLeft"),
      _vm._v(" "),
      _c("span", {
        staticClass: "lo-icon-btn__text",
        domProps: { innerHTML: _vm._s(_vm.text) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }